import { apiClient } from "@/lib/api/client";
import type {
  PlatformUserCreateBody,
  PlatformUserDto,
  PlatformUserListResponseDto,
  PlatformUserUpdateBody,
} from "@/lib/api/types/enterprise";

export async function listPlatformUsers(options?: {
  search?: string | null;
  limit?: number;
  offset?: number;
}): Promise<PlatformUserListResponseDto> {
  const params: Record<string, string> = {};
  if (options?.search?.trim()) {
    params.search = options.search.trim();
  }
  if (typeof options?.limit === "number") {
    params.limit = String(options.limit);
  }
  if (typeof options?.offset === "number") {
    params.offset = String(options.offset);
  }
  const { data } = await apiClient.get<PlatformUserListResponseDto>("/platform-users", {
    params,
    __skipTenantHeader: true,
  });
  return data;
}

export async function createPlatformUser(body: PlatformUserCreateBody): Promise<PlatformUserDto> {
  const { data } = await apiClient.post<PlatformUserDto>("/platform-users", body, { __skipTenantHeader: true });
  return data;
}

export async function updatePlatformUser(userId: string, body: PlatformUserUpdateBody): Promise<PlatformUserDto> {
  const { data } = await apiClient.patch<PlatformUserDto>(`/platform-users/${userId}`, body, { __skipTenantHeader: true });
  return data;
}

export async function deletePlatformUser(userId: string): Promise<void> {
  await apiClient.delete(`/platform-users/${userId}`, { __skipTenantHeader: true });
}
